"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostBlockCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var GhostBlockCard = function () {
    return (react_1.default.createElement("div", { className: "block-card" },
        react_1.default.createElement("div", { className: "saved-block-card__outer saved-block-card__outer--card" },
            react_1.default.createElement("div", { className: "card card--light saved-block-card" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "saved-block-card__placeholder" },
                        react_1.default.createElement(kaleidoscope_1.GhostBlock, null)),
                    react_1.default.createElement("div", { className: "saved-block-card__inner" },
                        react_1.default.createElement("div", { className: "saved-block-card__metadata" },
                            react_1.default.createElement("div", { className: "saved-block-card__text" },
                                react_1.default.createElement(kaleidoscope_1.GhostBlock, { className: "saved-block-card__name  saved-block-card__name--ghost" })))))))));
};
exports.GhostBlockCard = GhostBlockCard;
